
            const data = {"name":"ic-multiselect","data":{"width":"12","height":"8","viewBox":"0 0 12 8","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.883 7.383a1.25 1.25 0 0 1-1.767 0L.401 2.67A1.25 1.25 0 0 1 2.17.902L6 4.732 9.83.902a1.25 1.25 0 0 1 1.769 1.767L6.884 7.384h-.001Z\" _fill=\"#969FAB\"/>","originalColors":[{"type":"fill","color":"#969FAB"}],"stopColors":[]}}
        
                    module.exports = data
                    